export default __webpack_public_path__ + "static/media/likeInstagram.1046b1e9.svg";